import { Children, Dispatch, SetStateAction } from 'react'
import { LanguageTranslate } from '../../../../shared/Infraestructure/LanguageTranslate'
import { DtoTrabajos } from '../../../../Master/Home/Domain/DtoTrabajos'
import { DtoValorizacion } from '../Domain/DtoValorizacion'

interface iProps {
  trabajo: DtoTrabajos | null
  setValRechazadaXMetraje: Dispatch<SetStateAction<DtoValorizacion | null>>
  valRechazadaXMetraje: DtoValorizacion | null
  onSelectRechazada?: (val: DtoValorizacion) => void
}

export const ValorizacionesRechazadas = (props: iProps) => {
  const { trabajo, setValRechazadaXMetraje, valRechazadaXMetraje, onSelectRechazada } = props
  const langTranslate = LanguageTranslate()

  if (!trabajo?.Ultima_PreLiquidacion?.Valorizacion) return null

  const rechazadas = trabajo.Ultima_PreLiquidacion.Valorizacion.filter(
    v => v.Ultimo_Estado_Interno?.Descripcion === 'RECHAZADA POR METRAJE'
  )

  if (!rechazadas.length) return null

  return (
    <div className='mb-3'>
      <div className='alert alert-warning py-2 mb-2 d-flex align-items-center' style={{ fontSize: '0.9rem' }}>
        <i className='fa-solid fa-triangle-exclamation me-2' style={{ fontSize: '1.2rem', color: '#d9534f' }} />
        <span><strong>Valorizaciones Rechazadas por Metraje:</strong> Seleccione una para corregir su metraje.</span>
      </div>
      <table className='table table-sm table-striped table-bordered mb-2' style={{ backgroundColor: '#fff', fontSize: '0.85rem' }}>
        <thead className='table-dark'>
          <tr>
            <th scope='col' style={{ width: '45px' }} className='text-center'>ID</th>
            <th scope='col'>{langTranslate.general.Descripcion}</th>
            <th scope='col' className='text-center' style={{ width: '70px' }}>Cant. Ant.</th>
            <th scope='col' className='text-center' style={{ width: '50px' }}>Elegir</th>
          </tr>
        </thead>
        <tbody>
          {Children.toArray(
            rechazadas.map(val => {
              const isSelected = valRechazadaXMetraje?.ID_Valorizacion === val.ID_Valorizacion
              return (
                <tr style={{ backgroundColor: isSelected ? '#fff3cd' : undefined }}>
                  <td className='text-center align-middle'>{val.ID_Valorizacion}</td>
                  <td className='align-middle'>
                    <strong>{val.DetalleChile?.ManoObra?.Codigo || val.Codigo}</strong> - {val.DetalleChile?.ManoObra?.Nombre || val.Descripcion}
                    {val.Ultimo_Estado_Interno?.Observacion && (
                      <div className='text-danger' style={{ fontSize: '0.75rem' }}>
                        Obs: {val.Ultimo_Estado_Interno.Observacion}
                      </div>
                    )}
                  </td>
                  <td className='text-center align-middle'>{val.Cantidad?.toFixed(2)}</td>
                  <td className='text-center align-middle'>
                    <input
                      type='radio'
                      name='seleccionRechazada'
                      checked={isSelected}
                      onChange={() => {
                        setValRechazadaXMetraje(val as unknown as DtoValorizacion)
                        onSelectRechazada && onSelectRechazada(val as unknown as DtoValorizacion)
                      }}
                      style={{ cursor: 'pointer', transform: 'scale(1.2)' }}
                    />
                  </td>
                </tr>
              )
            })
          )}
        </tbody>
      </table>
    </div>
  )
}
